import ReactGA from 'react-ga4';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
 // Initialize GA4
 const TRACKING_ID = process.env.REACT_APP_GOOGLE_MEASUREMENT_ID
 ReactGA.initialize(TRACKING_ID, { debug: true });
 // Page Tracker Component
 export default function PageTracker() {
  const location = useLocation();
  
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
    // console.log(`Page view tracked: ${location.pathname}`);
  }, [location]);
  
  return null;
 }